import React, {Component} from 'react';
import "./callToAction.scss";
import {Link} from "gatsby";

class CallToAction extends Component {
    render() {
        let noTop = this.props.noTop ? "no-top" : "";
        let lineLeft = this.props.alignLeft ? "align-left" : "";
        return (
            <section className={`contact-container ${noTop} ${lineLeft}`}>
                <Link to={"/contact"} className={"btn white"}> let's chat </Link>
            </section>
        );
    }
}

export default CallToAction;